import React, { useState, useEffect } from 'react';
import { Checkbox } from 'antd';
import './UserView.css';
import Labels from './Labels.json';
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { acknowledgeSkillRepo, getSkillRepoStatus } from '../../services/Service';
import { fetchEmployeeData } from '../../util/documentConfig';
import { showErrorNotification, showNotification } from '../../util/documentConfig';
import SkillRepo from '../../components/SkillsetRepository/SkillRepo';
import axios from 'axios';
 
function DisplaySkillRepository({ onCompletion }) {
    const [isChecked, setIsChecked] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [userId, setUserId] = useState(null);
    const [modalVisible, setModalVisible] = useState(false); // State to manage modal visibility
    const { id } = useParams();
    const email = localStorage.getItem("userEmail");
    const token = useSelector((state) => state.auth.token);
    const normalUserId = localStorage.getItem("userrId");

    useEffect(() => {
        const roleUser = JSON.parse(localStorage.getItem("userRoles"));
        if (roleUser && roleUser.includes("ADMINUSER")) {
            setIsAdmin(true);
        }

        if (!id) {
            fetchData();
        } else {
            setUserId(id);
        }
    }, [id]);

    useEffect(() => {
        const checkSkillInDB = async () => {
            try {
                const res = await axios.get(`http://localhost:8080/skillset/${normalUserId}`, {
        headers: {
          'Authorization': `Bearer ${token}`, // Add this if token is required
        },
      });
      if (res.data.status === "Completed") {
        setIsChecked(true);
        onCompletion(true);
      }     else{
        onCompletion(false);
      }               
            } catch (error) {
                console.error('Error checking skill in DB:', error);
            }
        };
    
        checkSkillInDB();
    }, []);

    useEffect(() => {
        if (userId) {
            handleGetStatus();
        }
    }, [userId]);

    const fetchData = async () => {
        try {
            const fetchedUserId = await fetchEmployeeData(email);
            setUserId(fetchedUserId);
        } catch (error) {
            console.error("Failed to fetch userId:", error);
            showErrorNotification("Failed to fetch userId");
        }
    };

    const handleGetStatus = async () => {
        try {
            const res = await axios.get(`http://localhost:8080/skillset/${normalUserId}`, {
    headers: {
      'Authorization': `Bearer ${token}`, // Add this if token is required
    },
  });
  if (res.data.status === "Completed") {
    setIsChecked(true);
    onCompletion(true);
  }   else{
    onCompletion(false);
  }            
        } catch (error) {
            console.error('Error checking skill in DB:', error);
        }
    
       
       /* try {
            const status = await getSkillRepoStatus(userId);
            
            const isCompleted = status.data === "Completed";
            setIsChecked(isCompleted);
            onCompletion(isCompleted);

            localStorage.setItem(`skillRepo_${userId}`, isCompleted.toString());
        } catch (error) {
            console.error("Error fetching skill repository status:", error);
            setIsChecked(false);
            onCompletion(false);
        }*/
    };

    // Fetch compliance date immediately after submission
        const onSkillRepoCreate = async () => {
           
            try {
                
                    const response = await axios.get(`http://localhost:8080/skillset/${normalUserId}`, {
            headers: {
              'Authorization': `Bearer ${token}`, // Add this if token is required
            },
          });
            
                if (response.data.status === "Completed") {
                    showNotification("Skill Set added successfully!");
                    
                    // ✅ Fetch compliance date immediately after submission
                   // await fetchVDIComplianceDate();
        
                    // ✅ Ensure the tab updates instantly
                    setIsChecked(true);
                    onCompletion(true);
                    // handleGetStatus(); 
                    return response;
                } else {
                    throw new Error("Failed to save SkillSet Repository.");
                }
            } catch (error) {
                showErrorNotification("Failed to add SkillSet Repository");
            }
        };

    const handleCheckboxChange = async () => {
        if (!userId) {
            alert("User ID is not available");
            return;
        }

        const newStatus = !isChecked;
        setIsChecked(newStatus);
        onCompletion(newStatus);

        const requestData = { userId, status: newStatus ? "Completed" : "Not Completed" };
        const method = newStatus ? "POST" : "DELETE";

        try {
            const response = await acknowledgeSkillRepo(requestData, method);
            if (response.ok) {
                localStorage.setItem(`skillRepo_${userId}`, newStatus.toString());
                
                console.log("Operation successful:", response.data);
                showNotification(`Skill Repository ${newStatus ? "added" : "removed"} successfully!`);
            } else {
                const errorMsg = response.data;
                console.error("Operation failed:", errorMsg);
                showErrorNotification(`Failed to ${newStatus ? "add" : "remove"} Skill Repository record : ${errorMsg}`);
            }
        } catch (error) {
            console.error(`Error ${newStatus ? "adding" : "removing"} Skill Repository record :`, error);
        //    alert(`An error occurred while ${newStatus ? "adding" : "removing"} Skill Repository record.`);
        }
    };

    
  // Function to open the SkillRepo modal
  const showSkillRepoModal = () => {
    setModalVisible(true);
};

// Close the modal
const handleCloseModal = () => {
    setModalVisible(false);
};

    return (
        <div className="bordered-div userview_container">
            <h2 className='custom-h2'>{Labels.SkillRepository_Title}</h2>
            <p>
                {Labels.SkillRepository_Description}
                <br /><br />
                <strong>Note:</strong> {Labels.SkillRepository_Contact_Info}
                <a href={`mailto:${Labels.SkillRepository_Email}`}>
                    {Labels.SkillRepository_Email}
                </a>
                <br /> <br />
                
                
                {/* 🔹 If Admin is checking a normal user, show missing compliance message */}
                {isChecked && onCompletion ? (
                    <>
                     {
                    isAdmin?(
                        <>
                        <h4>
                            <strong>{Labels.SkillRepository_Walmart_Link_Label}</strong>
                             {/* <a href={Labels.SkillRepository_Walmart_Link_URL} target="_blank" rel="noopener noreferrer"> */}
                             <a onClick={showSkillRepoModal} target="_blank" rel="noopener noreferrer">
                           
                           {Labels.SkillRepository_Walmart_Link_View_Text}
                       </a>
                        </h4>
                        </>
                    ):(
                
                    <h4>
                    <strong>{Labels.SkillRepository_Walmart_Link_Label}</strong>
                     {/* <a href={Labels.SkillRepository_Walmart_Link_URL} target="_blank" rel="noopener noreferrer"> */}
                     <a onClick={showSkillRepoModal} target="_blank" rel="noopener noreferrer">
                   
                   {Labels.SkillRepository_Walmart_Link_Text} 
               </a>
                </h4>

                    )}
                <br/>
                <h4>✅ {Labels.SkillRepository_Completed_Label}</h4>
                </>
            ):(
                <>
                {isAdmin ? (
                    <>
                    <h4>
                    <strong>{Labels.SkillRepository_Walmart_Link_Label}</strong>
                     {/* <a href={Labels.SkillRepository_Walmart_Link_URL} target="_blank" rel="noopener noreferrer"> */}
                     <a onClick={showSkillRepoModal} target="_blank" rel="noopener noreferrer">
                   
                     {Labels.SkillRepository_Walmart_Link_View_Text}
               </a>
                </h4>
                
                <br/>
                      <h4 style={{ color: "red"}}>
                            {Labels.SkillRepository_Not_Completed_Label}
                        </h4>
                        </>
                    ) : (
                        <>
                <h4>
                    <strong>{Labels.SkillRepository_Walmart_Link_Label}</strong>
                     {/* <a href={Labels.SkillRepository_Walmart_Link_URL} target="_blank" rel="noopener noreferrer"> */}
                     <a onClick={showSkillRepoModal} target="_blank" rel="noopener noreferrer">
                   
                   {Labels.SkillRepository_Walmart_Link_Text} 
               </a>
                </h4>
                </>
                    )}
                    </>
                )}
            </p>
            <br />
          {/*  <div style={{ marginBottom: '16px' }}>
                <Checkbox
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    className="custom-checkbox"
                    disabled ={isAdmin}
                >
                    <strong style={{ color: "rgb(31, 64, 90)" }}>
                        {Labels.SkillRepository_Completed_Label}
                    </strong>
                </Checkbox>
            </div>*/}

            
             {/* SkillRepo Modal */}
             {setModalVisible&&(
             <SkillRepo 
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                onClose={handleCloseModal}
                userId={id}
                onSkillRepoCreate={onSkillRepoCreate}
            />
             )}
             
        </div>
    )
}

export default DisplaySkillRepository;
